/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react';

import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import {useNavigate} from 'react-router-dom';
import { Modal } from "react-bootstrap";
import InputMask from "react-input-mask";
import ReactLoading from 'react-loading';
import { useFormik } from 'formik';

import LoadingContent from '../../../modules/loading/LoadingContent';
import RenderError from '../../../utils/RenderError'

import {
  updateDocument,
} from "../../../services/profile";

const EditDocument = ({isOpen, onClosed}) => {
  const { profile } = useSelector((state : any) => ({
    profile: state.profile,
  }), shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState<any>(false);
  const [errors, setErrors] = useState<any>([]);

  const close = () => {
    setOpen(false);

    onClosed && onClosed();
  }

  useEffect(() => {
    if (isOpen === true) {
      setOpen(true);
      setErrors([]);

      formik.resetForm();
    } else {
      close();
    }
  }, [isOpen]);

  const formik = useFormik<any>({
    initialValues: {
      document: '',
    },
    onSubmit: (values) => {
      dispatch<any>(updateDocument(
        values.document
      )).then((response: any) => {
        close();
      })
      .catch(value => {
        setErrors(value);
      });
    },
  });

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open}
        onHide={() => close()}
        dialogClassName="custom-modal mw-700px"
        className="bg-black bg-opacity-75"
      >
          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-lg" className="py-1 flex-root d-flex justify-content-center">
              <h2 className="fd-uppercase">Complete seu cadastro</h2>
            </Modal.Title>

            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => close()}>
              <span className="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </Modal.Header>

          <Modal.Body>
            <form
              className="mx-auto mw-450px w-100 pt-0 pb-10"
              id="edit-document-form"
              onSubmit={formik.handleSubmit}
            >
              <div className="current" data-kt-stepper-element="content">
                <div className="w-100">
                  <div className='pb-5 pb-lg-8 text-center'>
                    <span className='me-5 text-justify fs-4 text-gray-800'>
                    Para prosseguir preencha com seu CPF
                    </span>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-column fv-row'>
                <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                  <span className='required'>CPF</span>
                </label>

                <InputMask
                  placeholder='444.444.444-44'
                  mask={"999.999.999-99"}
                  maskPlaceholder=""
                  maskChar=""
                  className='form-control form-control-solid-bg'
                  {...formik.getFieldProps('document')}
                />

                {errors && <RenderError error={errors['document']} />}

                <button
                  type='submit'
                  className='btn btn-lg btn-primary mt-5'
                  disabled={profile.actionsLoading}
                >
                  {!profile.actionsLoading && <>
                    Atualizar
                  </>}
                  {profile.actionsLoading && <span className="indicator-label">
                    Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>}
                </button>
              </div>
            </form>
          </Modal.Body>
      </Modal>
    </>
  )
}

export default EditDocument;
